import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const cache = {}; // projectId -> promise of non-group WBS items
function loadWbs(projectId) {
  if (!projectId) return Promise.resolve([]);
  if (!cache[projectId]) cache[projectId] = api.get(`/projects/${projectId}/wbs`).then(({ data }) => (data || []).filter((i) => !i.is_group)).catch(() => []);
  return cache[projectId];
}

/** WBS activity picker for one procurement line. Needs the project the document is for.
 * Value is the WBS item id (or "" for none). Disabled with a hint until a project is chosen.
 * Pass onPick(item) to also receive the full WBS item (code, name, ...) when one is chosen —
 * e.g. to auto-fill a line's description from the activity, instead of typing it separately. */
export function WbsItemSelect({ projectId, value, onChange, onPick, testId, allowNone = true }) {
  const [items, setItems] = useState([]);
  useEffect(() => { loadWbs(projectId).then(setItems); }, [projectId]);
  if (!projectId) {
    return <Select disabled value=""><SelectTrigger className="h-9 w-full" data-testid={testId}><SelectValue placeholder="Choose the project first" /></SelectTrigger><SelectContent /></Select>;
  }
  const handleChange = (v) => {
    const id = v === "none" ? "" : v;
    onChange(id);
    onPick?.(items.find((i) => i.id === id) || null);
  };
  return (
    <Select value={value || "none"} onValueChange={handleChange}>
      <SelectTrigger className="h-9 w-full" data-testid={testId}><SelectValue placeholder="Activity (optional)" /></SelectTrigger>
      <SelectContent className="max-h-72">
        {allowNone && <SelectItem value="none">Not linked to an activity</SelectItem>}
        {items.length === 0 && <div className="px-2 py-1.5 text-xs text-muted-foreground">No WBS items on this project</div>}
        {items.map((i) => <SelectItem key={i.id} value={i.id}>{i.code} — {i.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
